export const SET_TECHNIQUES = 'SET_TECHNIQUES';
export const REMOVE_TECHNIQUE = 'REMOVE_TECHNIQUE';
export const PUSH_TECHNIQUE = 'PUSH_TECHNIQUE';

export const SET_OFFER_TECHNIQUES = 'SET_OFFER_TECHNIQUES';
export const REMOVE_OFFER_TECHNIQUE = 'REMOVE_OFFER_TECHNIQUE';
export const PUSH_OFFER_TECHNIQUE = 'PUSH_OFFER_TECHNIQUE';